// export const baseurl = 'http://192.168.1.69:4400/api/'
// export const baseurImage = 'http://192.168.1.69:4400/'




// 
// export const baseurImage = 'https://medical.pinebh.com/server/'
// export const baseurl = 'https://medical.pinebh.com/server/api/'




export const baseurImage = 'https://sys.smcg.bh/Server/uploads/'
export const baseurl = 'https://sys.smcg.bh/Server/api/'



